import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2CourseIcon = ({
  color = "currentColor",
  strokeWidth = 1.65,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 21.207 13",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 13),
    children: [/*#__PURE__*/jsx("path", {
      d: "m20.5 6.5-2.667-2.667-2.667 2.667"
    }), /*#__PURE__*/jsx("path", {
      d: "m.5 6.5v-2.521a3.478 3.478 0 0 1 3.478-3.478h1.74a3.453 3.453 0 0 1 3.449 3.478v5.043a3.5 3.5 0 0 0 3.508 3.478h1.737a3.429 3.429 0 0 0 3.42-3.478v-5.188"
    })]
  });
};

export { PM2CourseIcon };
//# sourceMappingURL=course.js.map
